// "This day is already logged" -- the warn-then-proceed step of copying a trip
// leg into the Captain's Log.
//
// It warns rather than blocks because a second entry for one day is legitimate:
// a long day gets split, a delivery and a charter share a date, or the first
// entry was for a different boat's leg. What the reader needs is to tell "I
// already did this" from "there is an unrelated entry that day", so the matches
// are NAMED rather than counted.
//
// Props:
//   show      - visibility
//   onHide    - cancel; nothing is created
//   onConfirm - copy anyway
//   dayLabel  - the day, already formatted
//   matches   - the existing entries on that day ([{ id, title }])
//   busy      - a create is in flight

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const CopyLegToLogModal = ({ show, onHide, onConfirm, dayLabel, matches = [], busy }) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Already logged</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        {matches.length === 1
          ? `This logbook already has an entry for ${dayLabel}:`
          : `This logbook already has ${matches.length} entries for ${dayLabel}:`}
      </p>
      <ul className="mb-3">
        {matches.map((match) => (
          <li key={match.id}>{match.title}</li>
        ))}
      </ul>
      <p className="text-body-secondary mb-0">
        Copying again adds another entry for that day.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={busy}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm} disabled={busy}>
        Copy Anyway
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CopyLegToLogModal;
